var _excluded = ["viewBox"];
function cov_jbxjn22f4() {
  var path = "/app/src/components/logo/components/logo-en-black-on-transparent/logo-en-black-on-transparent.tsx";
  var hash = "8c9d20ce6d683289b974e0bb9d9edcb1a9b9d765";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-black-on-transparent/logo-en-black-on-transparent.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 40
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 49,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 40
          },
          end: {
            line: 5,
            column: 41
          }
        },
        loc: {
          start: {
            line: 8,
            column: 17
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 23
          }
        }],
        line: 6
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8c9d20ce6d683289b974e0bb9d9edcb1a9b9d765"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_jbxjn22f4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_jbxjn22f4();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
cov_jbxjn22f4().s[0]++;
export var LogoEnBlackOnTransparent = function LogoEnBlackOnTransparent(_ref) {
  var _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? (cov_jbxjn22f4().b[0][0]++, '0 0 90 31') : _ref$viewBox,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_jbxjn22f4().f[0]++;
  cov_jbxjn22f4().s[1]++;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M84.5707 6.55536L78.7153 30.0165L78.7021 30.0693H83.2618L89.138 6.55536H84.5707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1216 19.9039C11.4375 20.2557 10.6852 20.4367 9.9234 20.4327C8.28047 20.4327 7.34839 20.1579 7.24762 18.7635V18.6704C7.24762 18.6141 7.24105 18.5555 7.24105 18.5003V14.455L7.24762 13.9768V11.1213H7.24105V9.89362L7.24762 9.41196V6.65305L3.17535 7.21862C5.93328 6.65765 7.51377 4.3689 7.51377 2.0905V0.688049H2.93329V7.25771L2.6748 7.33358V19.4969C2.82595 22.9145 4.9749 24.9458 8.49186 24.9458C9.75218 24.9426 10.9988 24.6716 12.1567 24.1491L12.1797 24.1388V19.8717L12.1216 19.9039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8433 5.67126L0 7.74964V11.1684L12.8433 9.09002V5.67126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8433 10.6719L0 12.7503V16.015L12.8433 13.9378V10.6719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2546 12.2444C27.0728 8.45087 24.8122 6.19775 21.1276 6.19775C19.0104 6.19775 17.2645 7.05647 16.0794 8.68192C14.8943 10.3074 14.2744 12.6835 14.2744 15.5712C14.2744 18.4588 14.8987 20.843 16.0794 22.4684C17.2602 24.0939 19.0104 24.9515 21.1276 24.9515C24.8122 24.9515 27.0728 22.6903 27.2546 18.8727V24.5939H31.8307V6.5978L27.2546 7.3381V12.2444ZM27.4923 15.5712C27.4923 18.9347 25.81 21.1074 23.2065 21.1074C20.5219 21.1074 18.9195 19.0382 18.9195 15.5712C18.9195 12.0834 20.5219 10.0005 23.2065 10.0005C24.512 10.0005 25.6029 10.5338 26.3598 11.5443C27.1013 12.5318 27.4923 13.925 27.4923 15.5712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1797 6.19782C41.4941 6.19782 39.2334 8.44978 39.0538 12.2502V1.35938L34.4766 2.10083V24.5883H39.0538V18.8601C39.2334 22.6823 41.4941 24.9458 45.1797 24.9458C49.4929 24.9458 52.0679 21.442 52.0679 15.5712C52.0679 9.70049 49.4929 6.19782 45.1797 6.19782ZM43.0986 21.1074C40.4941 21.1074 38.8117 18.9348 38.8117 15.5712C38.8117 13.9251 39.2038 12.5318 39.9453 11.5478C40.7022 10.5374 41.7931 10.004 43.0986 10.004C45.7832 10.004 47.3856 12.0869 47.3856 15.5747C47.3889 19.0383 45.7865 21.1074 43.1019 21.1074H43.0986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5351 6.19782C60.8495 6.19782 58.5878 8.44978 58.4081 12.2502V1.35938L53.832 2.10083V24.5883H58.4016V18.8601C58.5812 22.6823 60.8429 24.9458 64.5286 24.9458C68.8407 24.9458 71.4157 21.442 71.4157 15.5712C71.4157 9.70049 68.8418 6.19782 64.5351 6.19782ZM62.4541 21.1074C59.8495 21.1074 58.1672 18.9348 58.1672 15.5712C58.1672 13.9251 58.5582 12.5318 59.2997 11.5478C60.0576 10.5374 61.1485 10.004 62.4541 10.004C65.1376 10.004 66.74 12.0869 66.74 15.5747C66.7378 19.0383 65.1354 21.1074 62.4541 21.1074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4268 6.55536H76.3139L80.2843 24.555H75.9032L71.4268 6.55536Z",
    fill: "black"
  }));
};